import React from "react";
import PropTypes from "prop-types";

import { Translate } from "utils";

import styles from "./SpaceSizeEdit.css";

const { t } = new Translate();

const Capacity = ({ capacity, onChange }) => (
  <div className={styles.root}>
    <input
      autoComplete="off"
      onChange={(e) => onChange({ ...capacity, value: e.target.value })}
      type="text"
      value={capacity.value}
    />
    <div className={styles.small}>{t(`units.${capacity.unit}`, 2)}</div>
  </div>
);

Capacity.propTypes = {
  capacity: PropTypes.shape({
    value: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    unit: PropTypes.string,
  }),
  onChange: PropTypes.func.isRequired,
};

export default Capacity;
